import { ref, watch, type Ref } from 'vue'
import { apiGet } from './apiGet'
import type { AgentSessionDevcontainerInfo } from '../stores/agent/types'

// Fetches box-side devcontainer/lifecycle detail for the info modal (#1501)
// whenever `threadId` changes. Best-effort: a 404 (session never started
// on the box, or already reaped) and an unreachable box both degrade to
// `info: null` rather than throwing — the modal shows "nothing to show"
// either way, same posture as the store's other box-proxied reads.
export function useAgentSessionDevcontainerInfo(threadId: Ref<string | null>) {
  const info = ref<AgentSessionDevcontainerInfo | null>(null)
  const loading = ref(false)

  watch(
    threadId,
    async (id) => {
      info.value = null
      if (!id) return
      loading.value = true
      try {
        info.value = await apiGet<AgentSessionDevcontainerInfo>(
          `/api/v1/agent/sessions/${encodeURIComponent(id)}/devcontainer`,
          { failureLabel: `Failed to load devcontainer info for ${id}`, onError: () => {} },
        )
      } finally {
        loading.value = false
      }
    },
    { immediate: true },
  )

  return { info, loading }
}
